var toTestRecord = function (fetchedTests) {
    var result = {};
    if (!fetchedTests)
        return result;
    Object.values(fetchedTests).forEach(function (testObj, index) {
        result[index] = testObj.data;
    });
    return result;
};
export default toTestRecord;
